lmApp
  .service('OperatorService', ['$rootScope', '$q', '$http',
    function ($rootScope, $q, $http) {
      var service = {};

      service.CheckToken = function (token) {
        var deferred = $q.defer();

        var request = {
          headers: {
            'X-Auth-Token': token,
            'X-Instance-Check': ''
          }
        };
        request.url = '/discovery:80/sdp/v2/operators/me';
        request.method = 'GET';

        $http(request)
          .then(function (response) {
            var answer = response.data;
            deferred.resolve(answer);
          }, function (response) {
            var reason = {};
            reason.url = request.url;
            reason.data = request.data;
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetToken = function(login, password) {
        var deferred = $q.defer();

        var request = {
          headers: {
            'X-Instance-Check': '',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        request.url = '/supervisor:80/1/auth';
        request.method = 'POST';
        request.data = transformRequest({
          'email': login,
          'password': password
        });

        $http(request)
            .then(function (response) {
              var answer = response.data;
              deferred.resolve(answer);
            }, function (response) {
              var reason = {};
              reason.url = request.url;
              reason.data = request.data;
              deferred.reject(reason)
            });
        return deferred.promise;
      };

      var transformRequest = function (data) {
        var params = [];
        for (var v in data)
          params.push(encodeURIComponent(v) + "=" + encodeURIComponent(data[v]));
        return params.join("&")
      };

      return service;
    }]);
